import { Helmet } from 'react-helmet-async';

const FAVICON_URL = 'https://customer-assets.emergentagent.com/job_b8d07c5d-fcca-4dc8-ad54-fc1da9664427/artifacts/9pft73hl_FAVICON.png';

const SEOHead = ({ 
  title, 
  description, 
  canonicalUrl,
  keywords = 'construction services UK, building contractors UK, renovation services UK, roofing contractors UK, demolition services UK, loft conversion UK'
}) => {
  const fullTitle = title.includes('EuroFortaleza') ? title : `${title} | EuroFortaleza`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      
      {/* Favicon */}
      <link rel="icon" type="image/png" href={FAVICON_URL} />
      <link rel="apple-touch-icon" href={FAVICON_URL} />
      
      {/* Canonical */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="EuroFortaleza" />
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="London, United Kingdom" />
    </Helmet>
  );
};

export default SEOHead;
